export const state = {
    firstFormStep: 1,
    formStep: 1,
    newMarketTest: {
        id: '',
        fields: {}
    }
};